import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Image,
  Input,
  Text,
  VStack,
  HStack,
  Textarea,
  IconButton,
  FormControl,
  FormLabel,
  FormHelperText,
  useToast,
} from '@chakra-ui/react';
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaEnvelope,
  FaLink,
} from 'react-icons/fa';
import { useState } from 'react';
import frame from '../assets/home/frame.png';

export default function ShareModal({ isOpen, onClose }) {
  const [recipientName, setRecipientName] = useState('');
  const [yourName, setYourName] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const toast = useToast();

  const handleSend = () => {
    if (!recipientName || !yourName || !recipientEmail) {
      toast({
        title: 'Incomplete Details',
        description: 'Please fill all required fields before sending.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Proceed with sending logic here
    console.log({ recipientName, yourName, recipientEmail });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: '4xl' }}>
      <ModalOverlay />
      <ModalContent bg="#F7F5F1">
        <ModalHeader>Share this creation</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={6} align="stretch">
            {/* Social Share */}
            <HStack spacing={4}>
              <IconButton icon={<FaFacebook />} aria-label="Facebook" />
              <IconButton icon={<FaInstagram />} aria-label="Instagram" />
              <IconButton icon={<FaTwitter />} aria-label="Twitter" />
              <IconButton icon={<FaEnvelope />} aria-label="Email" />
              <IconButton icon={<FaLink />} aria-label="Copy Link" />
              <Text>Copy link</Text>
            </HStack>

            {/* Form Area */}
            <HStack
              align="flex-start"
              flexDirection={{ base: 'column', md: 'row' }}
              spacing={6}
            >
              <Image
                src={frame}
                alt="jewellery"
                boxSize="200px"
                objectFit="cover"
                borderRadius="md"
              />

              <VStack spacing={4} flex="1">
                <FormControl isRequired>
                  <FormLabel>Recipient name</FormLabel>
                  <Input
                    placeholder="Insert Recipient name"
                    value={recipientName}
                    onChange={(e) => setRecipientName(e.target.value)}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>Your name</FormLabel>
                  <Input
                    placeholder="Insert your name"
                    value={yourName}
                    onChange={(e) => setYourName(e.target.value)}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>Recipient Email</FormLabel>
                  <Input
                    type="email"
                    placeholder="Insert Recipient email"
                    value={recipientEmail}
                    onChange={(e) => setRecipientEmail(e.target.value)}
                  />
                  <FormHelperText>
                    We'll never share the recipient's email.
                  </FormHelperText>
                </FormControl>
              </VStack>
            </HStack>

            <Textarea
              readOnly
              variant="unstyled"
              fontSize="sm"
              px={2}
              value={`Dear ${recipientName || '[Recipient Name]'},

✨ Someone's heart sparkles with a dream... ✨
${yourName || '[Your Name]'} has their eyes set on this timeless treasure from Rumi Diamond, and we thought you should know.

Because some wishes are meant to shine. 💎

With love,
R'Rumi Diamond`}
            />
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="gray" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSend}>
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
